import request from './index'
import type { LoginForm, BindForm } from '@/types/user'

export const loginByPassword = (data: LoginForm) => {
  return request.post('/user/login', data)
}

export const getQRCode = () => {
  return request.post('/user/getQRCode')
}

export const checkScanStatus = (key: string) => {
  return request.post('/user/checkScanStatus', {
    key,
    _t: Date.now(),
  })
}

export const loginByWechat = (key: string) => {
  return request.post('/user/loginByWechat', { key })
}

export const bindMobile = (data: BindForm) => {
  return request.post('/user/bind', data)
}

export const getUserInfo = () => {
  return request.get('/user/info')
}

export const getUserPrivilege = () => {
  return request.get('/user/privilege')
}

export const getUserDataViewRange = () => {
  return request.get('/user/data-view-range')
}

export const logout = () => {
  return request.post('/user/logout')
}

export const register = (data: {
  name: string
  companyName: string
  referralCode: string
  mobile: string
  pin: string
  password: string
}) => {
  return request.post('/user/register', data)
}

export const sendPin = (mobile: string, type: 'register' | 'forgot_password' = 'register') => {
  return request.post('/user/sendPin', { mobile, type })
}

export const resetPassword = (data: {
  mobile: string
  pin: string
  newPassword: string
}) => {
  return request.post('/user/resetPassword', data)
}
